<script>
    import {Link, navigate} from "svelte-routing";
    import {_} from '../lib/i18n';
    import {clickOutside} from "../lib/clickOutside";

    export let params = {};
    export let showMenu = false;

    export let identity = {};

    export let totalAnalyzes = 0;

    let email;
    $: email = identity ? identity.email : null;

    let title;
    $: title = (params && params.pageTitle) ? params.pageTitle : '';

    let titleTag;
    $: titleTag = (params && params.pageTitleTag) ? params.pageTitleTag : '';

    let pageCanonical;
    $: pageCanonical = (params && params.pageLinkCanonical) ? params.pageLinkCanonical : '';

    let pageMetaDescription;
    $: pageMetaDescription = (params && params.pageMetaDescription) ? params.pageMetaDescription : '';

    let pageId;
    $: pageId = (params && params.pageId) ? params.pageId : '';

    let path = '';
    $: path = (params && params.path) ? params.path : '';

    let isIndexPage = false;
    $: title && (isIndexPage = checkIsIndexPage());

    $: pageCanonical && initPageMetas();

    function initPageMetas() {
        document.title = titleTag;
        try {
            const canonical = document.querySelector('link[rel="canonical"]');
            if (canonical !== null) {
                canonical.href = pageCanonical;
            }
        } catch (err) {
            console.error(err);
        }
        try {
            document.querySelector('meta[name="description"]').setAttribute('content', pageMetaDescription);
        } catch (err) {

        }
    }

    function checkIsIndexPage() {
        return (title === $_('analyze.panelTitle'));
    }

    let menuIsOpened = false;
    function openMenu() {
        menuIsOpened = true;
    }
    function closeMenu(forceUpdate = false) {
        menuIsOpened = false;
        try {
            if (forceUpdate === true) window.shared.updateState;
        } catch (err) {
            console.error(err);
        }
    }

    function showSupportChat() {
        try {
            window.usedeskMessenger.open('chat');
        } catch (err) { console.error(err) }
        closeMenu();
    }

    function goBack() {
        if (pageId === 'order') {
            try {
                if (params && params.setState instanceof Function) {
                    params.setState({
                        pageId: '',
                    });
                }
            } catch (err) {
                console.error(err);
            }

            navigate(`${path}/dashboard/subscription`);
        } else {
            navigate(`${path}/dashboard/`);
        }
    }

    function handleClickOutside(event) {
        menuIsOpened = false;
    }
</script>

<header class="header">
    <div class="container">

        {#if isIndexPage}
        <Link to={`${path}/dashboard/`} class="header__logo-wrapper" on:click={closeMenu}>
            <div class="header__logo-img">
                <img src={$_('header.logoSmall')} />
            </div>
            <div class="header__logo-text">
                <img src={$_('header.logo')} />
            </div>
        </Link>

        {:else}
            <button on:click={goBack} class="header__btn-back btn-no-style">
                <div class="button button_icony button_icony-40">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.625 14.25L7.08211 9.70711C6.69158 9.31658 6.69158 8.68342 7.08211 8.29289L11.625 3.75" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </div>
            </button>
        {/if}

        <div class="header__page-title">{title}</div>

        {#if showMenu}
        <div class="header__menu-btn" on:click={openMenu}>
            <div class="button button_icony button_icony-40">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="7" y="10" width="7" height="2" rx="1" fill="#343439" />
                    <rect x="4" y="6" width="10" height="2" rx="1" fill="#343439" />
                </svg>
            </div>
        </div>
        <div class={`header-menu ${menuIsOpened ? 'open' : ''}`} use:clickOutside on:click_outside={handleClickOutside}>
            <div class="header-menu__header">
                <p class="header-menu__title">{$_('header.menuLabel')}</p>
                <div class="button button_icony button_icony-40 header-menu__close-btn" on:click={closeMenu}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 7.5L6.25 4.75C5.83579 4.33579 5.16421 4.33579 4.75 4.75C4.33579 5.16421 4.33579 5.83579 4.75 6.25L7.5 9L4.75 11.75C4.33579 12.1642 4.33579 12.8358 4.75 13.25C5.16421 13.6642 5.83579 13.6642 6.25 13.25L9 10.5L11.75 13.25C12.1642 13.6642 12.8358 13.6642 13.25 13.25C13.6642 12.8358 13.6642 12.1642 13.25 11.75L10.5 9L13.25 6.25C13.6642 5.83579 13.6642 5.16421 13.25 4.75C12.8358 4.33579 12.1642 4.33579 11.75 4.75L9 7.5Z" fill="#3B3E43" />
                    </svg>
                </div>
            </div>

            <div class="header-menu__wrapper">
                <div class="header-menu__group">
                    <Link to={`${path}/dashboard/`} class="header-menu__item" on:click={closeMenu}>
                        <div class="header-menu__item-icon">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.77778 10.7222V18.5C5.77778 19.6046 6.67321 20.5 7.77778 20.5H12M5.77778 10.7222L11.2929 5.20711C11.6834 4.81658 12.3166 4.81658 12.7071 5.20711L17.5 10M5.77778 10.7222L4 12.5M18.2222 10.7222V18.5C18.2222 19.6046 17.3268 20.5 16.2222 20.5H12M18.2222 10.7222L20 12.5M18.2222 10.7222L17.5 10M17.5 10V6.5M12 20.5V15.5" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <p class="header-menu__item-text">{$_('header.homeLabel')}</p>
                    </Link>

                    <Link to={`${path}/dashboard/add-account`} class="header-menu__item" on:click={closeMenu}>
                        <div class="header-menu__item-icon">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 20.5V19.5C4 16.7386 6.23858 14.5 9 14.5H12.75M17.5355 14.4645V18M17.5355 18V21.5355M17.5355 18H21.0711M17.5355 18H14M15 7.5C15 9.70914 13.2091 11.5 11 11.5C8.79086 11.5 7 9.70914 7 7.5C7 5.29086 8.79086 3.5 11 3.5C13.2091 3.5 15 5.29086 15 7.5Z" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <p class="header-menu__item-text">{$_('header.addAccountLabel')}</p>
                    </Link>

                    <Link to={`${path}/dashboard/tutorial`} class="header-menu__item" on:click={closeMenu}>
                        <div class="header-menu__item-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 14V7C20 5.34315 18.6569 4 17 4H7C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H13.5M20 14L13.5 20M20 14H15.5C14.3954 14 13.5 14.8954 13.5 16V20" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 8H16" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 12H12" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <p class="header-menu__item-text">{$_('header.tutorialsLabel')}</p>
                    </Link>

                    <Link to={`${path}/dashboard/subscription`} class="header-menu__item" on:click={() => closeMenu(params.initTariff !== null)}>
                        <div class="header-menu__item-icon">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="3" y="6.5" width="18" height="13" rx="2" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M3 10.5H20.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7 15.5H9" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <p class="header-menu__item-text">{$_('header.subscriptionLabel')}</p>
                    </Link>

                    <a href="#" on:click={showSupportChat} class="header-menu__item">
                        <div class="header-menu__item-icon">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 10.5H6.75C7.44036 10.5 8 11.0596 8 11.75V15.25C8 15.9404 7.44036 16.5 6.75 16.5H6C4.34315 16.5 3 15.1569 3 13.5C3 11.8431 4.34315 10.5 6 10.5ZM6 10.5V9.5C6 6.18629 8.68629 3.5 12 3.5C15.3137 3.5 18 6.18629 18 9.5V10.5M18 10.5H17.25C16.5596 10.5 16 11.0596 16 11.75V15.25C16 15.9404 16.5596 16.5 17.25 16.5H18M18 10.5C19.6569 10.5 21 11.8431 21 13.5C21 15.1569 19.6569 16.5 18 16.5M18 16.5L17.3787 18.9851C17.1561 19.8754 16.3562 20.5 15.4384 20.5H13" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <p class="header-menu__item-text">{$_('header.supportLabel')}</p>
                    </a>
                </div>
                <div class="header-menu__group">
                    <Link to={`${path}/dashboard/notification-settings`} class="header-menu__item" on:click={closeMenu}>
                        <div class="header-menu__item-icon">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.82474 14.434L5.09976 13.7452L5.82474 14.434ZM8 9.5C8 7.29086 9.79086 5.5 12 5.5V3.5C8.68629 3.5 6 6.18629 6 9.5H8ZM8 12.2564V9.5H6V12.2564H8ZM6 16.5C6 15.9658 6.20812 15.4823 6.54971 15.1228L5.09976 13.7452C4.41915 14.4616 4 15.4329 4 16.5H6ZM7 16.5H6V18.5H7V16.5ZM17 16.5H7V18.5H17V16.5ZM18 16.5H17V18.5H18V16.5ZM17.4503 15.1228C17.7919 15.4823 18 15.9658 18 16.5H20C20 15.4329 19.5809 14.4616 18.9002 13.7452L17.4503 15.1228ZM16 9.5V12.2564H18V9.5H16ZM12 5.5C14.2091 5.5 16 7.29086 16 9.5H18C18 6.18629 15.3137 3.5 12 3.5V5.5ZM18.9002 13.7452C18.2923 13.1054 18 12.6579 18 12.2564H16C16 13.55 16.8905 14.5336 17.4503 15.1228L18.9002 13.7452ZM4 16.5C4 17.6046 4.89543 18.5 6 18.5V16.5H4ZM18 18.5C19.1046 18.5 20 17.6046 20 16.5H18V18.5ZM6 12.2564C6 12.6579 5.70766 13.1054 5.09976 13.7452L6.54971 15.1228C7.10947 14.5336 8 13.55 8 12.2564H6Z" fill="#161516" />
                                <path d="M13.7976 20.3767C13.6312 20.7179 13.3712 21.0046 13.048 21.2035C12.7247 21.4023 12.3516 21.5051 11.9721 21.4998C11.5926 21.4945 11.2224 21.3813 10.9049 21.1735C10.5873 20.9657 10.3354 20.6718 10.1786 20.3262" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 3.5V4.5" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <p class="header-menu__item-text">{$_('header.notificationsLabel')}</p>
                    </Link>

                    <Link to={`${path}/dashboard/settings`} class="header-menu__item" on:click={closeMenu}>
                        <div class="header-menu__item-icon">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.07179 6.76794L6.57179 5.90192L6.07179 6.76794ZM4.70577 7.13397L3.83974 6.63397L3.83974 6.63397L4.70577 7.13397ZM3.70577 8.86602L2.83974 8.36602H2.83974L3.70577 8.86602ZM4.07179 10.232L3.57179 11.0981H3.57179L4.07179 10.232ZM4.07179 14.7679L3.57179 13.9019H3.57179L4.07179 14.7679ZM3.70577 16.134L4.57179 15.634H4.57179L3.70577 16.134ZM4.70577 17.866L3.83974 18.366H3.83974L4.70577 17.866ZM6.07179 18.232L6.57179 19.0981L6.07179 18.232ZM17.9282 18.232L17.4282 19.0981L17.4282 19.0981L17.9282 18.232ZM19.2942 17.866L18.4282 17.366L19.2942 17.866ZM20.2942 16.134L21.1602 16.634L20.2942 16.134ZM19.9282 14.7679L19.4282 15.634V15.634L19.9282 14.7679ZM19.9282 10.232L20.4282 11.0981V11.0981L19.9282 10.232ZM20.2942 8.86602L19.4282 9.36602L19.4282 9.36602L20.2942 8.86602ZM19.2942 7.13397L18.4282 7.63397L19.2942 7.13397ZM17.9282 6.76794L18.4282 7.63397L17.9282 6.76794ZM14.6512 7.11604L14.2088 8.01283L14.6512 7.11604ZM16.5118 7.58573L17.0118 8.45175L16.5118 7.58573ZM15.3358 7.51204L14.7792 8.34277L15.3358 7.51204ZM17.9871 12.1035L16.9892 12.1686L17.9871 12.1035ZM18.5116 11.0499L18.0116 10.1839L18.5116 11.0499ZM15.3358 17.488L14.7792 16.6572L15.3358 17.488ZM16.5118 17.4143L16.0118 18.2803L16.5118 17.4143ZM18.5116 13.9501L18.0116 14.8161L18.5116 13.9501ZM9.34876 17.884L9.79121 16.9872L9.34876 17.884ZM7.48823 17.4143L6.98823 16.5482L7.48823 17.4143ZM8.66415 17.488L8.10747 18.3187L8.66415 17.488ZM14.6512 17.884L15.0937 18.7808L14.6512 17.884ZM5.48837 11.0499L4.98837 11.9159L5.48837 11.0499ZM6.01289 12.1035L5.01501 12.0385L6.01289 12.1035ZM7.48824 7.58573L6.98824 8.45176L7.48824 7.58573ZM11 4.5V4.5V2.5C9.89543 2.5 9 3.39543 9 4.5H11ZM11 6.13424V4.5H9V6.13424H11ZM9.22084 8.34277C9.40297 8.22073 9.59345 8.1104 9.79121 8.01283L8.90631 6.21924C8.62907 6.35603 8.3623 6.51056 8.10748 6.68131L9.22084 8.34277ZM5.57179 7.63397L6.98824 8.45176L7.98824 6.7197L6.57179 5.90192L5.57179 7.63397ZM5.57179 7.63397L6.57179 5.90192C5.61521 5.34963 4.39203 5.67738 3.83974 6.63397L5.57179 7.63397ZM4.57179 9.36602L5.57179 7.63397L3.83974 6.63397L2.83974 8.36602L4.57179 9.36602ZM4.57179 9.36602L4.57179 9.36602L2.83974 8.36602C2.28746 9.32261 2.61521 10.5458 3.57179 11.0981L4.57179 9.36602ZM5.98837 10.1839L4.57179 9.36602L3.57179 11.0981L4.98837 11.9159L5.98837 10.1839ZM7 12.5C7 12.3885 7.00363 12.278 7.01076 12.1686L5.01501 12.0385C5.00505 12.1912 5 12.3451 5 12.5H7ZM7.01076 12.8314C7.00363 12.722 7 12.6115 7 12.5H5C5 12.6549 5.00505 12.8088 5.01501 12.9615L7.01076 12.8314ZM4.57179 15.634L5.98836 14.8161L4.98836 13.0841L3.57179 13.9019L4.57179 15.634ZM4.57179 15.634L4.57179 15.634L3.57179 13.9019C2.61521 14.4542 2.28746 15.6774 2.83974 16.634L4.57179 15.634ZM5.57179 17.366L4.57179 15.634L2.83974 16.634L3.83974 18.366L5.57179 17.366ZM5.57179 17.366L5.57179 17.366L3.83974 18.366C4.39203 19.3226 5.61521 19.6504 6.57179 19.0981L5.57179 17.366ZM6.98823 16.5482L5.57179 17.366L6.57179 19.0981L7.98823 18.2803L6.98823 16.5482ZM9.79121 16.9872C9.59345 16.8896 9.40296 16.7793 9.22083 16.6572L8.10747 18.3187C8.3623 18.4894 8.62907 18.644 8.90631 18.7808L9.79121 16.9872ZM11 20.5V18.8658H9V20.5H11ZM11 20.5H9C9 21.6046 9.89543 22.5 11 22.5V20.5ZM13 20.5H11V22.5H13V20.5ZM13 20.5V22.5C14.1046 22.5 15 21.6046 15 20.5H13ZM13 18.8658V20.5H15V18.8658H13ZM14.7792 16.6572C14.597 16.7793 14.4065 16.8896 14.2088 16.9872L15.0937 18.7808C15.3709 18.644 15.6377 18.4894 15.8925 18.3187L14.7792 16.6572ZM18.4282 17.366L17.0118 16.5482L16.0118 18.2803L17.4282 19.0981L18.4282 17.366ZM18.4282 17.366H18.4282L17.4282 19.0981C18.3848 19.6504 19.608 19.3226 20.1602 18.366L18.4282 17.366ZM19.4282 15.634L18.4282 17.366L20.1602 18.366L21.1602 16.634L19.4282 15.634ZM19.4282 15.634V15.634L21.1602 16.634C21.7125 15.6774 21.3848 14.4542 20.4282 13.9019L19.4282 15.634ZM18.0116 14.8161L19.4282 15.634L20.4282 13.9019L19.0116 13.0841L18.0116 14.8161ZM17 12.5C17 12.6115 16.9964 12.722 16.9892 12.8314L18.985 12.9615C18.9949 12.8088 19 12.6549 19 12.5H17ZM16.9892 12.1686C16.9964 12.278 17 12.3885 17 12.5H19C19 12.3451 18.9949 12.1912 18.985 12.0385L16.9892 12.1686ZM19.4282 9.36602L18.0116 10.1839L19.0116 11.9159L20.4282 11.0981L19.4282 9.36602ZM19.4282 9.36602L19.4282 9.36602L20.4282 11.0981C21.3848 10.5458 21.7125 9.32261 21.1602 8.36602L19.4282 9.36602ZM18.4282 7.63397L19.4282 9.36602L21.1602 8.36602L20.1602 6.63397L18.4282 7.63397ZM18.4282 7.63397V7.63397L20.1602 6.63397C19.608 5.67738 18.3848 5.34963 17.4282 5.90192L18.4282 7.63397ZM17.0118 8.45175L18.4282 7.63397L17.4282 5.90192L16.0118 6.7197L17.0118 8.45175ZM14.2088 8.01283C14.4065 8.1104 14.597 8.22072 14.7792 8.34277L15.8925 6.68131C15.6377 6.51056 15.3709 6.35603 15.0937 6.21924L14.2088 8.01283ZM13 4.5V6.13423H15V4.5H13ZM13 4.5H15C15 3.39543 14.1046 2.5 13 2.5V4.5ZM11 4.5H13V2.5H11V4.5ZM15.0937 6.21924C15.0509 6.19815 15.023 6.17053 15.0092 6.15025C14.9971 6.13248 15 6.12788 15 6.13423H13C13 7.00299 13.549 7.68731 14.2088 8.01283L15.0937 6.21924ZM16.0118 6.7197C16.0172 6.71655 16.0147 6.72132 15.9935 6.71972C15.9693 6.71789 15.9318 6.70762 15.8925 6.68131L14.7792 8.34277C15.3914 8.75303 16.2592 8.88623 17.0118 8.45175L16.0118 6.7197ZM18.985 12.0385C18.9819 11.9913 18.9918 11.9537 19.0024 11.9318C19.0116 11.9126 19.017 11.9128 19.0116 11.9159L18.0116 10.1839C17.2602 10.6177 16.9413 11.4342 16.9892 12.1686L18.985 12.0385ZM15.8925 18.3187C15.9318 18.2924 15.9693 18.2821 15.9935 18.2803C16.0147 18.2787 16.0172 18.2834 16.0118 18.2803L17.0118 16.5482C16.2592 16.1138 15.3914 16.247 14.7792 16.6572L15.8925 18.3187ZM19.0116 13.0841C19.017 13.0872 19.0116 13.0874 19.0024 13.0682C18.9918 13.0462 18.9819 13.0087 18.985 12.9615L16.9892 12.8314C16.9413 13.5658 17.2602 14.3823 18.0116 14.8161L19.0116 13.0841ZM8.90631 18.7808C8.94907 18.8019 8.97696 18.8295 8.99079 18.8497C9.00291 18.8675 9 18.8721 9 18.8658H11C11 17.997 10.451 17.3127 9.79121 16.9872L8.90631 18.7808ZM7.98823 18.2803C7.98277 18.2834 7.98524 18.2787 8.00646 18.2803C8.03069 18.2821 8.06821 18.2924 8.10747 18.3187L9.22083 16.6572C8.6086 16.247 7.74076 16.1138 6.98823 16.5482L7.98823 18.2803ZM15 18.8658C15 18.8721 14.9971 18.8675 15.0092 18.8497C15.023 18.8295 15.0509 18.8019 15.0937 18.7808L14.2088 16.9872C13.549 17.3127 13 17.997 13 18.8658H15ZM5.01501 12.9615C5.01808 13.0086 5.00818 13.0462 4.99762 13.0682C4.98836 13.0874 4.98295 13.0872 4.98836 13.0841L5.98836 14.8161C6.73975 14.3823 7.05867 13.5658 7.01076 12.8314L5.01501 12.9615ZM4.98837 11.9159C4.98295 11.9128 4.98836 11.9126 4.99762 11.9318C5.00818 11.9537 5.01808 11.9913 5.01501 12.0385L7.01076 12.1686C7.05867 11.4342 6.73976 10.6177 5.98837 10.1839L4.98837 11.9159ZM8.10748 6.68131C8.06822 6.70763 8.0307 6.71789 8.00647 6.71972C7.98525 6.72133 7.98278 6.71655 7.98824 6.7197L6.98824 8.45176C7.74077 8.88623 8.60861 8.75303 9.22084 8.34277L8.10748 6.68131ZM9 6.13424C9 6.12788 9.00291 6.13248 8.99079 6.15025C8.97696 6.17053 8.94907 6.19815 8.90631 6.21924L9.79121 8.01283C10.451 7.68731 11 7.00299 11 6.13424H9Z" fill="#161516" />
                                <circle cx="12" cy="12.5" r="3" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <p class="header-menu__item-text">{$_('header.settingsLabel')}</p>
                    </Link>

                    <a href={$_('header.affiliateProgramUrl')} class="header-menu__item" target="_blank">
                        <div class="header-menu__item-icon">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12.5" r="9" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M14.5 9.58333L14.3563 9.46356C13.9968 9.16403 13.5438 9 13.0759 9H10.75C9.7835 9 9 9.7835 9 10.75V10.75C9 11.7165 9.7835 12.5 10.75 12.5H13.25C14.2165 12.5 15 13.2835 15 14.25V14.25C15 15.2165 14.2165 16 13.25 16H10.412C9.8913 16 9.39114 15.7969 9.01782 15.434L9 15.4167" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 8.5L12 7.5" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 17.5V16.5" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <p class="header-menu__item-text">{$_('header.affilateProgramLabel')}</p>
                        <div class="header-menu__item-icon_new-tab">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.25 3.75H5.25C4.42157 3.75 3.75 4.42157 3.75 5.25V12.75C3.75 13.5784 4.42157 14.25 5.25 14.25H12.75C13.5784 14.25 14.25 13.5784 14.25 12.75V9.1875M14.25 3.75H11.25M14.25 3.75V6.75M14.25 3.75L6.75 11.25" stroke="#88879B" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </a>

                    {#if window.allowed_dev}
                        <a href={window.dev_access_link} class="header-menu__item" target="_blank">
                            <p class="header-menu__item-text">Dev-server</p>
                        </a>
                    {/if}
                </div>
            </div>
            <div class="header-menu__footer">
                <a href={`/instashpion/logout`} class="header-menu__item">
                    <div class="header-menu__item-icon">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 17V19.5C15 20.6046 14.1046 21.5 13 21.5H6C4.89543 21.5 4 20.6046 4 19.5V5.5C4 4.39543 4.89543 3.5 6 3.5H13C14.1046 3.5 15 4.39543 15 5.5V8.5625M11 12.5H21M21 12.5L18.5 10M21 12.5L18.5 15" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <p class="header-menu__item-text">{$_('header.logOutLabel')}</p>
                </a>

                <div class="header-menu__account-info">
                    <p class="header-menu__account-label">{$_('header.accountLabel')}</p>
                    <p class="header-menu__account-name">{email}</p>
                </div>
            </div>
        </div>
        {/if}
    </div>
</header>

<style>
    @media (max-width: 500px) {
        .header-menu {
            max-width: 100%;
        }
    }

    @media (min-width: 501px) {
        .header-menu {
            max-width: 360px;
        }
    }

    @media (min-width: 1114px) {
        .header__logo-img {
            display: none;
        }
    }
    @media (max-width: 1113px) {
        .header__logo-text {
            display: none!important;
        }
    }

    .header-menu__account-name {
        word-break: break-all;
    }

    .btn-no-style {
        border: none;
        background-color: transparent;
    }
</style>